import { signalTypeIconMap } from "app/pages/sales-intelligence/modules/signals/constants/signalTypeIcons";

/**
 * @deprecated use `getIconForSignalType` from
 * "app/pages/sales-intelligence/modules/signals/constants/signalTypeIcons".
 *
 * Kept as a re-export so existing call sites keep working while they migrate; the map itself now lives
 * with the signals module rather than being duplicated here.
 */
export const iconNamePerSignalType = signalTypeIconMap;
